/* eslint-disable @typescript-eslint/no-explicit-any */

export function mergeObjects(object: object, source: object) {
  if (object === source) return object;
  const merged: object = {};
  Object.keys({ ...object, ...source }).forEach((key) => {
    (merged as any)[key] = (source as any)[key] || (object as any)[key];
  });
  return merged;
}
